export const PROPERTY_LIST_ACTION = "PROPERTY_LIST_ACTION";
export const PROPERTY_LIST_SUCCESS = "PROPERTY_LIST_SUCCESS";
export const PROPERTY_LIST_ALL_ACTION = "PROPERTY_LIST_ALL_ACTION";
export const PROPERTY_LIST_ALL_SUCCESS = "PROPERTY_LIST_ALL_SUCCESS";
export const PROPERTY_LIST_LOAD_ALL_ACTION = "PROPERTY_LIST_LOAD_ALL_ACTION";
export const PROPERTY_LIST_LOAD_ALL_SUCCESS = "PROPERTY_LIST_LOAD_ALL_SUCCESS";
export const PROPERTY_TOUR_LIST_ALL_ACTION = "PROPERTY_TOUR_LIST_ALL_ACTION";
export const PROPERTY_TOUR_LIST_ALL_SUCCESS = "PROPERTY_TOUR_LIST_ALL_SUCCESS";
export const PROPERTY_CREATE_ACTION = "PROPERTY_CREATE_ACTION";
export const PROPERTY_CREATE_SUCCESS = "PROPERTY_CREATE_SUCCESS";
export const PROPERTY_CREATE_FAIL = "PROPERTY_CREATE_FAIL";
export const PROPERTY_DELETE_ACTION = "PROPERTY_DELETE_ACTION";
export const PROPERTY_DELETE_SUCCESS = "PROPERTY_DELETE_SUCCESS";
export const PROPERTY_GET_UPDATE_ACTION = "PROPERTY_GET_UPDATE_ACTION";
export const PROPERTY_GET_UPDATE_SUCCESS = "PROPERTY_GET_UPDATE_SUCCESS";
export const PROPERTY_UPDATE_ACTION = "PROPERTY_UPDATE_ACTION";
export const PROPERTY_UPDATE_SUCCESS = "PROPERTY_UPDATE_SUCCESS";
export const PROPERTY_FAIL = "PROPERTY_FAIL";

export const PROPERTY_CREATE_TRANSLATE_ACTION = "PROPERTY_CREATE_TRANSLATE_ACTION";
export const PROPERTY_CREATE_TRANSLATE_SUCCESS = "PROPERTY_CREATE_TRANSLATE_SUCCESS";

export const PROPERTY_UPDATE_TRANSLATE_ACTION = "PROPERTY_UPDATE_TRANSLATE_ACTION";
export const PROPERTY_UPDATE_TRANSLATE_SUCCESS = "PROPERTY_UPDATE_TRANSLATE_SUCCESS";

export const PROPERTY_DELETE_TRANSLATE_ACTION = "PROPERTY_DELETE_TRANSLATE_ACTION";
export const PROPERTY_DELETE_TRANSLATE_SUCCESS = "PROPERTY_DELETE_TRANSLATE_SUCCESS";